import api from "../api";

export const uploadPatientImage = async (patientId, image, rename, config) => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('patient_id', patientId);
    formData.append('rename', rename);

    return api.post('/patients/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        ...config
    });
}

export const getPatientFilesList = async (patientId) => {
    return api.get(`/patients/${patientId}/images`);
}

export const getFile = (file_name) => {
    return process.env.REACT_APP_API_URL + '/uploads/' + file_name;
}

export const deletePatientFile = async (patientId, fileId) => {
    return api.delete(`/patients/${patientId}/images/${fileId}/delete`);
}

export const getPatientFile = async (patientId, fileId) => {
    return api.get(`/patients/${patientId}/images/${fileId}`);
}

export const postWirnklesAnalysis = async (image, generate_mask = true, generate_wrinkles = true, upload_to_cloud = true) => {

    return api.post(process.env.REACT_APP_WRINKLE_API_URL + '/analyze-wrinkles', {
        generate_mask,
        generate_wrinkles,
        upload_to_cloud,
        image: image,
    });
}

export const postLessionDetector = async (image, interpolation = 'bicubic', patch_size = 512, score_thr = 0.3, stride = 256, target_size = 512, upload_to_cloud = true) => {
    return api.post(process.env.REACT_APP_SKIN_LESION_DETECTOR_URL + '/api/detect', {
        image: image,
        interpolation,
        patch_size,
        score_thr,
        stride,
        target_size,
        upload_to_cloud
    });
}

export const getLessionDetector = async (task_id) => {
    return api.get(process.env.REACT_APP_SKIN_LESION_DETECTOR_URL + '/api/task/' + task_id);
}

export const saveImageAnalysis = async ({patient_id, analysis_id, analysis_type = 1, image_id}) => {
    return api.post(`/patients/${patient_id}/analysis`, {
        analysis_id,
        analysis_type,
        image_id
    })
}

export const getAllAnalysis = async (patient_id) => {
    return api.get(`/patients/${patient_id}/analysis`);

}